export const normalizeEmail = (email)=>email.trim().toLowerCase();
